import { MachineModel } from "interfaces/machine-model";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: MachineModel[];
}

interface LazyFetchMachineModel {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetMachineModels = (): {
  loading: boolean;
  error: boolean;
  fetchMachineModel: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const {
    loading,
    error,
    fetchCallback
  }: LazyFetchMachineModel = useLazyFetchV2("GET");

  return {
    loading,
    error,
    fetchMachineModel: (queryString?: string) =>
      fetchCallback(`machine_models?${queryString ?? ""}`)
  };
};
